
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as healthpENGuaX7W9Dx9NlKrvVrbRHpwErppJXToQ3dKDUBvY0Meta } from "/codebuild/output/src3878069130/src/bitbucket.org/magusa/cavu-workspaces/apps/psf/pages/health.vue?macro=true";
import { default as _91_46_46_46slug_93LSRwopQMdVC6_45LglFFgsM9q3Ub08MrKYbPqSVRq_45bBoMeta } from "/codebuild/output/src3878069130/src/bitbucket.org/magusa/cavu-workspaces/apps/_base/pages/[...slug].vue?macro=true";
import { default as port_45parkinglYy5PRW1jLFE6mSSkw2HnPd4mtAapS8HZachYpxS0G4Meta } from "/codebuild/output/src3878069130/src/bitbucket.org/magusa/cavu-workspaces/apps/psf/pages/[IATA]/port-parking.vue?macro=true";
import { default as airport_45hotels5Q9GxJTyWB8kUeiCtpM0Qp_b8SZujkP3Cf1I1f6rw4IMeta } from "/codebuild/output/src3878069130/src/bitbucket.org/magusa/cavu-workspaces/apps/psf/pages/[IATA]/airport-hotels.vue?macro=true";
import { default as airport_45parkingvSNzcBnGI1OPxYW2KY_45E3ocqGDfd08xm2582mIKkC70Meta } from "/codebuild/output/src3878069130/src/bitbucket.org/magusa/cavu-workspaces/apps/psf/pages/[IATA]/airport-parking.vue?macro=true";
import { default as _91code_93_45_91name_93_45_91IATA_93LFzrNTioT7IpYa0wjS2DgnlJYWZX_v26AXAOVJlKo5AMeta } from "/codebuild/output/src3878069130/src/bitbucket.org/magusa/cavu-workspaces/apps/psf/pages/hro/[code]-[name]-[IATA].vue?macro=true";
import { default as _91code_93_45_91name_93_45_91IATA_93tKzKPR_45WYbryEvl_45g9F9WmMrE__45qLY6PZuoNSa_45nGfoMeta } from "/codebuild/output/src3878069130/src/bitbucket.org/magusa/cavu-workspaces/apps/psf/pages/parking/[code]-[name]-[IATA].vue?macro=true";
import { default as port_45hotels_45with_45parkingg1KJwiDs4lTK9n_45exTbGKjjLajliNMjU_45tIJpAWHtpEMeta } from "/codebuild/output/src3878069130/src/bitbucket.org/magusa/cavu-workspaces/apps/psf/pages/[IATA]/port-hotels-with-parking.vue?macro=true";
import { default as airport_45hotels_45with_45parkingcsonpj_45ZHfcBUmk7vhqxSx5SD5LeR_dxXMIv_SrBuAEMeta } from "/codebuild/output/src3878069130/src/bitbucket.org/magusa/cavu-workspaces/apps/psf/pages/[IATA]/airport-hotels-with-parking.vue?macro=true";
import { default as _91code_93_45_91name_93_45_91IATA_93_1VFch1J19DijU0SWnY0RyKM9pUcSsvAgDWXPaDJZsQMeta } from "/codebuild/output/src3878069130/src/bitbucket.org/magusa/cavu-workspaces/apps/psf/pages/hotel-package/[code]-[name]-[IATA].vue?macro=true";
import { default as component_45stubVNl7aY5cmZE46xb9__Rh6Z7ulStVPBIHB5_45mAXv6_Q8Meta } from "/codebuild/output/src3878069130/src/bitbucket.org/magusa/cavu-workspaces/node_modules/.pnpm/nuxt@3.16.2_@parcel+watcher@2.5.1_@types+node@22.15.30_db0@0.3.2_eslint@8.57.1_ioredis@_935be90a342b90b74572fc2e5d890be0/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubVNl7aY5cmZE46xb9__Rh6Z7ulStVPBIHB5_45mAXv6_Q8 } from "/codebuild/output/src3878069130/src/bitbucket.org/magusa/cavu-workspaces/node_modules/.pnpm/nuxt@3.16.2_@parcel+watcher@2.5.1_@types+node@22.15.30_db0@0.3.2_eslint@8.57.1_ioredis@_935be90a342b90b74572fc2e5d890be0/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "health___en",
    path: "/health",
    component: () => import("/codebuild/output/src3878069130/src/bitbucket.org/magusa/cavu-workspaces/apps/psf/pages/health.vue")
  },
  {
    name: "slug___en",
    path: "/:slug(.*)*",
    component: () => import("/codebuild/output/src3878069130/src/bitbucket.org/magusa/cavu-workspaces/apps/_base/pages/[...slug].vue")
  },
  {
    name: "IATA-port-parking___en",
    path: "/:IATA()/port-parking",
    component: () => import("/codebuild/output/src3878069130/src/bitbucket.org/magusa/cavu-workspaces/apps/psf/pages/[IATA]/port-parking.vue")
  },
  {
    name: "IATA-airport-hotels___en",
    path: "/:IATA()/airport-hotels",
    component: () => import("/codebuild/output/src3878069130/src/bitbucket.org/magusa/cavu-workspaces/apps/psf/pages/[IATA]/airport-hotels.vue")
  },
  {
    name: "IATA-airport-parking___en",
    path: "/:IATA()/airport-parking",
    component: () => import("/codebuild/output/src3878069130/src/bitbucket.org/magusa/cavu-workspaces/apps/psf/pages/[IATA]/airport-parking.vue")
  },
  {
    name: "hro-code-name-IATA___en",
    path: "/hro/:code()-:name()-:IATA()",
    component: () => import("/codebuild/output/src3878069130/src/bitbucket.org/magusa/cavu-workspaces/apps/psf/pages/hro/[code]-[name]-[IATA].vue")
  },
  {
    name: "parking-code-name-IATA___en",
    path: "/parking/:code()-:name()-:IATA()",
    component: () => import("/codebuild/output/src3878069130/src/bitbucket.org/magusa/cavu-workspaces/apps/psf/pages/parking/[code]-[name]-[IATA].vue")
  },
  {
    name: "IATA-port-hotels-with-parking___en",
    path: "/:IATA()/port-hotels-with-parking",
    component: () => import("/codebuild/output/src3878069130/src/bitbucket.org/magusa/cavu-workspaces/apps/psf/pages/[IATA]/port-hotels-with-parking.vue")
  },
  {
    name: "IATA-airport-hotels-with-parking___en",
    path: "/:IATA()/airport-hotels-with-parking",
    component: () => import("/codebuild/output/src3878069130/src/bitbucket.org/magusa/cavu-workspaces/apps/psf/pages/[IATA]/airport-hotels-with-parking.vue")
  },
  {
    name: "hotel-package-code-name-IATA___en",
    path: "/hotel-package/:code()-:name()-:IATA()",
    component: () => import("/codebuild/output/src3878069130/src/bitbucket.org/magusa/cavu-workspaces/apps/psf/pages/hotel-package/[code]-[name]-[IATA].vue")
  },
  {
    name: component_45stubVNl7aY5cmZE46xb9__Rh6Z7ulStVPBIHB5_45mAXv6_Q8Meta?.name,
    path: "/sitemap.xml",
    component: component_45stubVNl7aY5cmZE46xb9__Rh6Z7ulStVPBIHB5_45mAXv6_Q8
  }
]